'use strict';
import {
    debounce,
    isPhablet,
    easeOutExpo
} from '../../../_js/_helper';

export default class Navigation {
    constructor() {

        //highlight the navigation primary that is active - this is only for prototype , remove for Build
        if ($('.navigation-to-highlight').length) {
            let navMenu = $('.navigation-to-highlight').text();
            $('.lvl1 a').each(function (i, ele) {
                if ($(this).text() === navMenu) {
                    $(this).addClass('nav-highlight');
                }
            });
        }

        //end

        //highlight the navigation primary that is active - this is for build. Add class 'current-nav' to the page user is currently on
        if ($('.nav-highlight').length) {
            let $navMenuParent = $('.lvl2 .nav-highlight').parents('.lvl1 > li').find('>a');
            $navMenuParent.addClass('nav-highlight');
        }

        //end

        const that = this,
            $body = $('body'),
            el = $('#navigation'),
            $nav = el.find('.nav'),
            $lvl1 = el.find('.lvl1'),
            $lvl2 = el.find('.lvl2'),
            $lvl3 = el.find('.lvl3'),
            $set = $lvl1.add($lvl2).add($lvl3),
            $primaryNav = $('.js-mobile-menu'),
            $subNav = $('.js-sub-nav'),
            subNavMarkup = '<button class="sub-nav js-sub-nav icon-arrow" name="Sub-navigation"></button>';

        let isMobileDevice = isPhablet();

        that.$window = $(window);
        that.$visibleArea = 0;

        // Insert Subnav Markup after Level 1 menu items
        $lvl1.find('ul').each(function () {
            if ($(this).find('li').length) {
                $(this).before(subNavMarkup);
            }

        });

        that.checkNavHeight();

        that.$window.on('resize orientationchange', debounce(function () {
            that.checkNavHeight();
        }, 250));



        $primaryNav.on('click', function (e) {

            e.preventDefault();
            e.stopPropagation();

            const $this = $(this);

            el.toggleClass('active');
            $this.toggleClass('active');
            $nav.toggleClass('active');
            $lvl1.toggleClass('active');
            $body.toggleClass('overflow-hidden');
            $('html').toggleClass('overflow-hidden');


            if ($this.hasClass('active')) {
                $lvl1.slideDown(easeOutExpo);
            } else {
                $set
                    .removeClass('active')
                    .find('.icon-arrow.active')
                    .removeClass('active');

                $lvl2.slideUp(easeOutExpo);
                $lvl3.slideUp(easeOutExpo);
            }
        });

        el.on('touchend, click', $subNav, function (e) {

            const $this = $(e.target),
                $grandParent = $this.parent().parent(),
                $next = $this.next();

            if (!$next.hasClass('search-input-icon')) {
                if ($this.hasClass('active')) {
                    if ($next.hasClass('lvl2')) {
                        $set
                            .find('.icon-arrow.active')
                            .removeClass('active');

                        $this.removeClass('active')
                            .next().find('.icon-arrow.active')
                            .removeClass('active');

                        $lvl3.slideUp(easeOutExpo);

                        $next.removeClass('active').slideUp(easeOutExpo);
                    } else {
                        $this.removeClass('active');
                        $next.removeClass('active').slideUp(easeOutExpo);
                    }
                } else {
                    if ($grandParent.hasClass('lvl1')) {
                        $lvl1
                            .find('.icon-arrow.active')
                            .removeClass('active')
                            .next().removeClass('active').slideUp(easeOutExpo);
                    } else if ($grandParent.hasClass('lvl2')) {
                        $lvl2
                            .find('.icon-arrow.active')
                            .removeClass('active')
                            .next().removeClass('active').slideUp(easeOutExpo);
                    }

                    $this.addClass('active');

                    setTimeout(function () {
                        $next.addClass('active');
                    }, 200);

                    $next.slideDown(easeOutExpo);
                }
            }
        });

        // Primary Nav Mouse Listeners
        el.on('click', '.no-link', function (e) {
            e.preventDefault();

            const $this = $(this),
                $next = $this.next();

            $next.trigger('click');

        }).on('click', '.lvl2 a', function (e) {
            const $this = $(this),
                $next = $this.next();

            if ($this.attr('src') === '#' && $this.parent().hasClass('no-link')) {
                $next.trigger('click');
            }

        }).on('mouseenter', '.lvl1 li', function () {

            const $this = $(this),
                $next = $this.find('> .lvl2');

            if (!isMobileDevice) {
                $this.addClass('opened');
                $next.stop().slideDown(easeOutExpo);
                $this.siblings('.lvl2');
            }
        }).on('mouseleave', '.lvl1 li', function () {
            const $this = $(this),
                $next = $this.find('> .lvl2');


            if (!isMobileDevice) {
                $this.removeClass('opened');
                $next.stop().slideUp(easeOutExpo);
            }
        });

        $body.on('click', function (e) {
            const $eTarget = $(e.target);

            if ($eTarget.hasClass('nav active') && !$eTarget.parents('.nav').length) {
                if ($primaryNav.hasClass('active')) {
                    $primaryNav.trigger('click');
                }

                $('.js-sub-nav.active').trigger('click');
            }

            if ($('.lvl1 .drop-down-active').length && !$eTarget.parents('.nav').length) {
                $('.lvl1 .drop-down-active').parents('.lvl1').find('.lvl2').stop().slideUp(easeOutExpo);
                $('.lvl1 .drop-down-active').removeClass('.drop-down-active');


            }

            if ($('.js-mobile-menu.active').length && !$eTarget.parents('.nav').length) {

                $('.js-mobile-menu').click();
                $('.nav').removeClass('active');
                return;
            }

        });

        // Window Listener
        that.$window.on('resize orientationchange', debounce(function () {
            isMobileDevice = isPhablet();

            if (isMobileDevice) {
                $primaryNav.removeClass('active');
                $set
                    .find('.icon-arrow.active')
                    .removeClass('active');
                $('.js-sub-nav.active').trigger('click');
                $('.js-mobile-menu.active').trigger('click');
                $nav.removeClass('active');
                $lvl1.removeClass('active');
                $lvl2.hide();
                $lvl3.hide();
            } else {
                $lvl1.show();
                $('.js-mobile-menu.active').trigger('click');
                $('.js-sub-nav.active').trigger('click');
                $nav.removeClass('active');
                $('.lvl1 li').removeClass('opened');

            }
        }, 250));

        that.$window.on('scroll', debounce(function () {
            isMobileDevice = isPhablet();

            if (!isMobileDevice) {
                $('.js-sub-nav.active').trigger('click');
            }
        }, 250));

        $('#navigation .lvl1 > li ').on('focus', '> a', function (e) {
            const $this = $(this).parent(),
                $next = $this.find('> .lvl2');

            if (!isMobileDevice) {
                $this.siblings('.drop-down-active').removeClass('drop-down-active');

                $this.siblings('li').find('.lvl2').stop().slideUp(easeOutExpo);
                $next.focus();
                $next.stop().slideDown(easeOutExpo);
                $this.toggleClass('drop-down-active');
            }
        });

        $('#navigation .lvl2 > li:last-child ').on('blur', '> a', function (e) {
            $(this).parents('.lvl2').slideUp(easeOutExpo);
        });


        $('#navigation .lvl1 > li > a').on({
            'touchstart': function (e) {

                const $this = $(this).parent(),
                    $next = $this.find('> .lvl2');

                if (!isMobileDevice) {
                    if ($this.hasClass('drop-down-active')) {
                        $next.slideUp(easeOutExpo);
                    } else {
                        e.preventDefault();
                        $this.siblings('.drop-down-active').removeClass('drop-down-active');
                        $this.siblings('li').find('.lvl2').stop().slideUp(easeOutExpo);
                        $this.toggleClass('drop-down-active');
                        $next.slideDown(easeOutExpo);
                    }


                }
            }
        });


    }

    checkNavHeight() {
        const that = this,
            $navLvl1 = $('#navigation .lvl1');

        that.$visibleArea = that.$window.outerHeight() - $('.header').outerHeight();

        $navLvl1.css({
            height: that.$visibleArea
        });
    }


}
